import { useEffect } from 'react';

function useComponentDidMount(fn: () => void) {
    useEffect(() => {
        fn();
    }, []);
}

export default useComponentDidMount;
